import React, { useEffect } from "react";
import Dropdown from "../../static/Dropdown/Dropdown";
import { dropdownItem } from "../../static/Dropdown/types";
import "./player-tabs.scss";

interface category {
  label: string;
  value: string;
  active?: Boolean;
}

interface tourTabProps {
  tours: dropdownItem[];
  selectedTour: dropdownItem;
  tourCategories: category[];
}

export const PlayerProfileTourTabs = (props: tourTabProps) => {
  const { tours, selectedTour, tourCategories } = props;

  return (
    <div className="pprofile-tour-tabs">
      <div className="container pprofile-tour-tabs__container">
        <Dropdown
          value={selectedTour}
          options={tours}
          onChange={value => {
            location.href = `${value.value}`;
          }}
        />
        <nav className="pprofile-tour-tabs__categories">
          {tourCategories.map(category => {
            return (
              <a
                key={category.label}
                className={`pprofile-tour-tabs__tab ${
                  category.active ? "active" : ""
                }`}
                href={category.value}
              >
                {category.label}
              </a>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

interface infoTabProps {
  selectedTab:
    | "Overview"
    | "Activity"
    | "Rankings"
    | "Points"
    | "Titles"
    | "Slams";
}

export const scrollToPProfileTabs = () => {
  if (window.location.hash === "#pprofile-info-tabs") {
    const infoTabs = document.querySelector(".pprofile-info-tabs");
    const siteHeader = document.querySelector("#site-header") as HTMLElement;
    if (infoTabs && siteHeader) {
      const infoTabY = infoTabs.getBoundingClientRect().top;
      const siteHeaderHeight = siteHeader.offsetHeight;
      window.scroll(0, infoTabY - siteHeaderHeight);
    }
  }
};

export const PlayerProfileInfoTabs = (props: infoTabProps) => {
  const { selectedTab } = props;

  useEffect(() => {
    scrollToPProfileTabs();
  });

  return (
    <div className="pprofile-info-tabs">
      <nav className="pprofile-info-tabs__container container">
        <ul className="pprofile-info-tabs__tab-list">
          <li
            className={`pprofile-info-tabs__tab-list-item pprofile-info-tabs__tab-list-item--overview ${
              selectedTab === "Overview" ? "active" : ""
            }`}
          >
            <a title="Overview" href="#0">
              Overview
            </a>
          </li>
          <li
            className={`pprofile-info-tabs__tab-list-item pprofile-info-tabs__tab-list-item--activity ${
              selectedTab === "Activity" ? "active" : ""
            }`}
          >
            <a title="Activity" href="#0">
              Activity
            </a>
          </li>
          <li
            className={`pprofile-info-tabs__tab-list-item pprofile-info-tabs__tab-list-item--year-end-rankings ${
              selectedTab === "Rankings" ? "active" : ""
            }`}
          >
            <a title="Year End rankings" href="#0">
              Year End rankings
            </a>
          </li>
          <li
            className={`pprofile-info-tabs__tab-list-item pprofile-info-tabs__tab-list-item--points-breakdown ${
              selectedTab === "Points" ? "active" : ""
            }`}
          >
            <a title="Points Breakdown" href="#0">
              Points Breakdown
            </a>
          </li>
          <li
            className={`pprofile-info-tabs__tab-list-item pprofile-info-tabs__tab-list-item--titles ${
              selectedTab === "Titles" ? "active" : ""
            }`}
          >
            <a title="Titles" href="#0">
              Titles
            </a>
          </li>
          <li
            className={`pprofile-info-tabs__tab-list-item pprofile-info-tabs__tab-list-item--grand-slams ${
              selectedTab === "Slams" ? "active" : ""
            }`}
          >
            <a title="Grand Slams" href="#0">
              Grand Slams
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};
